import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { useFormik } from "formik";
import toast from "react-hot-toast";

import { FaRegCircleXmark } from "react-icons/fa6";

import "../Asociados/createAsociados.css";

//src/components/proto/components/Ventas/createOrden.css
//import "./../Ventas/createOrden.css";
import { createPaqueteFormValidation } from "../../../../helper/validate";

import * as api from "helper/helper";
import "./../formsCommons.css";

import styles from "./../tooltip.module.css";
import createOrdenStyles from "./../Ventas/createOrden.module.css";

//import { EstadoBodega } from "../../../../helper/const";
import { Singleton } from "helper/tools";
import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import LoadingButton from "../LoadingButton/LoadingButton";
import AutocompleteGo from "../Autocomplete/AutocompleteGo";
import CreateClient from "../Clientes/CreateClient";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import { useTimeout } from "../../hooks/useTimeout";
//import SelectBonificacion from "./SelectBonificacion";
import ErrorModal from "./../Ventas/ErrorModal";
import { CurrencyInput } from "components/CurrencyInput";

const CreatePaquete = forwardRef(({ item, reloadProducto }, ref) => {
  const modalRef = useRef();
  const buttonCancelModalRef = useRef();

  const createClientesRef = useRef();
  //const selectBonificacionRef = useRef();
  const errorModalRef = useRef();
  //  const [modalDataBonificacion, setModalDataBonificacion] = useState(null);

  //  const refAutocompleteAsociados = useRef(null);
  const refAutocompleteProducto = useRef(null);
  //const refAutocompleteClientes = useRef(null);

  /// CHECAR  useTraceUpdate(props, "CreatePaquete");
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  /*  const [asociados, setAsociados] = useState([]);
  const [clientes, setClientes] = useState([]);*/
  const [productos, setProductos] = useState([]);
  const [canSave, setCanSave] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [defaultOnlyAsociadoId, setDefaultOnlyAsociadoId] = useState();
  /*const [disableCrearOrden, setDisableCrearOrden] = useState(true);*/
  const [disableSeleccionarCantidad, setDisableSeleccionarCantidad] =
    useState(true);
  const [disableAgregarProducto, setDisableAgregarProducto] = useState(true);
  /*  const [hasBonificaciones, setHasBonificaciones] = useState(true);

  const [roles, setRoles] = useState([]);
  const [ordenSubtotal, setOrdenSubtotal] = useState(0);
  const [ordenDescuento, setOrdenDescuento] = useState(0);*/

  const [errorCantidad, setErrorCantidad] = useState("");

  const [ordenTotal, setOrdenTotal] = useState(0);
  const [productosAgregados, setProductosAgregados] = useState([]);

  const [ordenBlocked, setOrdenBlocked] = useState(false);

  const { clearTimers, addAlert } = useTimeout();

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const createMode = item == null || (item && Object.keys(item).length === 0);

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    setProductosAgregados([]);
    setProductos([]);

    //  setOrdenSubtotal(0);
    setOrdenTotal(0);
    //  setOrdenDescuento(0);

    refAutocompleteProducto.current.clearInput();

    if (item == null) {
      return;
    }

    formik?.resetForm();

    loadItem(item);
  }, [item]);

  const searchFetchData = async (text) => {
    const criteria = {
      isActivo: true,
      texto: text,
      page: 1,
      pageSize: 25,
    };

    const responseProductos = await api.searchProductos(criteria).catch((e) => {
      toast.error("Error al pedir producto.");
    });
    if (!responseProductos) return;

    setProductos(responseProductos.data.subset);
  };

  useEffect(() => {
    formik?.resetForm();

    const newPermissions = PermissionsForSection(Sections.Clientes);
    setPermissions(newPermissions);
  }, []);

  let initialValues = {
    id: 0,
    nombre: "",
    paqueteId: null,
    productos: [],
    cantidad: 1,
    precio: 0,
  };

  if (!createMode) {
    initialValues = {
      id: item.id,

      nombre: item.nombre,
      paqueteId: item.paqueteId,
      productos: productosAgregados,
      cantidad: 1,
      precio: 0,
    };
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: createPaqueteFormValidation,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      // normalize
      const paqueteProductos = productosAgregados.map((item) => {
        return {
          productoId: item.producto.id,
          cantidad: item.cantidad,
          precio: item.precioEnPaquete ?? item.precio,
          id: item.id,
        };
      });

      let payload = {
        nombre: values.nombre.trim(),
        productos: paqueteProductos,
      };

      if (values.id === 0) {
        setIsLoading(true);
        const toastId = toast.loading("Creando Paquete...");
        let response = await api.createPaquete(payload).catch((e) => {
          toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al Crear Paquete. ${e.mensaje}`);
            setIsLoading(false);
            return;
          }
          toast.error("Error al Paquete.");
          setIsLoading(false);
        });

        setIsLoading(false);
        toast.dismiss(toastId);

        if (!response) return;

        toast.success("Paquete creado.");
        reloadProducto();

        buttonCancelModalRef.current.click();
      } else {
        const toastId = toast.loading("Actualizando Paquete...");
        setIsLoading(true);
        const response = await api
          .updatePaquete(values.id, payload)
          .catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            toast.error("Error al actualizar Paquete.");
          });
        if (!response) return;

        toast.dismiss(toastId);
        setIsLoading(false);

        toast.success("Paquete actualizado.");
        reloadProducto();

        buttonCancelModalRef.current.click();
      }
    },
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  function addProduct(e) {
    const cantidad = parseInt(formik.values.cantidad);

    if (isNaN(cantidad)) {
      toast.error(
        "Error al pedir agregar producto. Cantidad debe de contener solo numeros",
      );
      return;
    }

    let item = null;
    const itemAgregadoIndex = productosAgregados.findIndex(
      (item) => item.producto.id === formik.values.productId,
    );
    if (itemAgregadoIndex === -1) {
      item = productos.find((item) => item.id === formik.values.productId);
      if (item == null) {
        toast.error("Error al pedir agregar producto.");
        return;
      }
    } else {
      item = productosAgregados[itemAgregadoIndex];
    }

    //item.maxCantidad = item.cantidad;
    //  item.cantidad = cantidad;
    //  item.precio = item.precioVenta;
    //  item.subTotal = item.cantidad * item.precio;
    //item.total = item.subTotal;

    let newProductosAgregados = [...productosAgregados];
    if (itemAgregadoIndex === -1) {
      newProductosAgregados.push({
        cantidad: cantidad,
        producto: item,
        precio: item.precioVenta,
        subTotal: cantidad * item.precioVenta,
        //precioEnPaquete: null,
        precioEnPaquete: item.precioVenta,
        //newPrecio: formik.values.precio,
      });

      //limpiar
      /// glow si ya existe
      newProductosAgregados = newProductosAgregados.map((producto) => {
        producto.canPulse = false;
        return producto;
      });
    } else {
      //ya existe mostrar visualmente
      toast.error("Producto ya agregado.");

      /// glow si ya existe
      newProductosAgregados = newProductosAgregados.map((producto) => {
        producto.canPulse = false;
        if (producto === item) {
          producto.canPulse = true;
        }
        return producto;
      });
    }

    setProductosAgregados(newProductosAgregados);

    formik.setFieldValue("productos", newProductosAgregados);

    //  calculateTotals(newProductosAgregados);

    /*
      const id = e == null ? 0 : parseInt(e.id);
                            formik.setFieldValue("productId", id);

                            formik.setFieldValue("productSelected", e);*/

    formik.setFieldValue("cantidad", 1); //formik.values.cantidad);
    formik.setFieldValue("productId", "");
    formik.setFieldValue("productSelected", null);

    refAutocompleteProducto.current.clearInput();

    setTimeout(() => {
      formik.validateForm();
    }, 500);
  }

  function removeProduct(index) {
    if (index === -1) {
      return;
    }

    let newProductosAgregados = [...productosAgregados];
    newProductosAgregados[index].bonificaciones = [];

    newProductosAgregados[index].descuento = 0;
    newProductosAgregados[index].promocionId = null;

    /*
      currentValue.descuento = descuento;
      currentValue.total = currentValue.subTotal - descuento;
      currentValue.promocionId = promocion.id;
      */
    newProductosAgregados.splice(index, 1);

    formik.setFieldValue("productos", newProductosAgregados);

    setProductosAgregados(newProductosAgregados);

    //  calculateTotals(newProductosAgregados);
  }

  function refreshCanSave() {
    let toSave = productosAgregados.some(
      (producto) => producto?.errorPrecio?.length > 0,
    );
    setCanSave(toSave);
  }

  function updateProduct(index, newCantidad, newPrecio) {
    if (index === -1) {
      return;
    }

    let producto = productosAgregados[index];
    producto.cantidad = newCantidad;
    //  producto.subTotal = producto.cantidad * producto.precio;
    producto.precioEnPaquete = newPrecio;
    producto.subTotal = producto.cantidad * newPrecio; //producto.precio;
    producto.total = producto.subTotal;

    let errorPrecio = "";
    //TODO checar si es menor de 45% margen
    var precioMargen = producto?.producto?.precioCosto / 0.55;
    if (newPrecio < precioMargen) {
      const formatPrecioMargen = Singleton.getInstance().format(precioMargen);
      errorPrecio = `Precio debe ser mínimo arriba de ${formatPrecioMargen}`;
    }
    producto.errorPrecio = errorPrecio;

    setProductosAgregados([...productosAgregados]);

    let newProductosAgregados = [...productosAgregados];

    formik.setFieldValue("productos", newProductosAgregados);

    setProductosAgregados(newProductosAgregados);

    refreshCanSave();

    //calculateTotals(newProductosAgregados);
  }
  /*
  const calculateTotals = (productosAgregados) => {
    const initialValue = 0;
    const sums = productosAgregados.reduce((accumulator, currentValue) => {
      /*
         item.precioVenta;
    item.subTotal = item.cantidad * item.precio;
    * /
      return accumulator + currentValue.cantidad * currentValue.precio;
    }, initialValue);

    //item.total = item.cantidad * item.precio;
    const descuento = productosAgregados.reduce((accumulator, currentValue) => {
      currentValue.descuento = 0;
      currentValue.promocionId = null;

      console.log("---> XXX ");
      if (
        currentValue.bonificaciones == null ||
        currentValue.bonificaciones?.length === 0
      )
        return accumulator;

      const promocion = currentValue.bonificaciones[0];
      const promocionDetalle = promocion.promocionDetalles[0];

      /**
       * Regalo en Compra
       * /
      if (
        promocionDetalle !== PROMOCIONES_STATES.REGALO_EN_COMPRA.id &&
        sums < promocionDetalle.compraMinima
      ) {
        return accumulator;
      }

      let descuento =
        currentValue.subTotal * (promocionDetalle.descuento / 100);
      /**
       * VEnta Interna aplicar descuentoProducto de la pantalla por el personalizado del %
       * /
      if (promocion.id === PROMOCIONES_STATES.VENTA_INTERNA.id) {
        //descuento = currentValue.subTotal * (promocion.descuentoPorcentaje / 100);
        //--descuento = promocion.descuentoTotal;
        descuento =
          currentValue.subTotal - promocion.nuevoTotal * currentValue.cantidad;

        //TEST
        //descuento = parseFloat(descuento.toFixed(2));
      }
      /*
        no pueden valer 0 lo gratis por el SAT tiene que valer 1c
        * /
      if (promocionDetalle.descuento === 100) {
        descuento -= 0.01;
      }
      currentValue.descuento = descuento;
      currentValue.total = currentValue.subTotal - descuento;
      currentValue.promocionId = promocion.id;

      return accumulator + descuento;
    }, 0);

    setOrdenSubtotal(sums);
    setOrdenDescuento(descuento);

    const total = sums - descuento;
    setOrdenTotal(total);

    validateOrder();
  };*/

  useEffect(() => {
    validateOrder();
  }, [ordenTotal]);

  const validateOrder = () => {
    //  validateAsociadoCredito();
    //  validateAsociadoCongelado();
    validateOrderStatus();
  };

  const validateOrderStatus = () => {
    /*  if (item?.estatuOrden == null) {
      setOrdenBlocked(false);
      return;
    }
    //completado 3
    setOrdenBlocked(ORDEN_VENTA_STATUS.EN_PROCESO.id !== item.estatuOrden.id);*/
  };
  /*
  const validateAsociadoCongelado = () => {
    if (asociadoIdRef.current === 0) {
      setAsociadoCongelado(false);
      return;
    }

    let asociado = asociados.find((item) => item.id === asociadoIdRef.current);
    if (asociado == null) {
      setAsociadoCongelado(false);
      return;
    }
    setAsociadoCongelado(asociado.info?.congelado ?? false);
  };

  const validateAsociadoCredito = () => {
    if (asociadoIdRef.current === 0) {
      setCreditoSuperado(false);
      return;
    }

    let asociado = asociados.find((item) => item.id === asociadoIdRef.current);

    if (asociado == null) {
      setCreditoSuperado(false);
      return;
    }

    const creditoDisponible = asociado.info?.creditoDisponible;

    const superado = ordenTotal > creditoDisponible;
    setCreditoSuperado(superado);
  };*/

  function loadItem(newItem) {
    const isEmpty = newItem && Object.keys(newItem).length === 0;
    if (isEmpty) {
      setOrdenBlocked(false);
      return;
    }

    refAutocompleteProducto.current.clearInputOnly();
    //refAutocompleteAsociados.current.clearInputOnly();
    //refAutocompleteClientes.current.clearInputOnly();

    const productos = newItem.productos;

    const paqueteProductos = productos.map((item) => {
      const precio =
        (item.precio ?? 0) > 0 ? item.precio : item.producto.precioVenta;
      return {
        cantidad: item.cantidad,
        producto: item.producto,
        precioEnPaquete: precio,
        subTotal: item.cantidad * precio,
        id: item.id,
      };
    });

    setProductosAgregados(paqueteProductos);

    formik.setFieldValue("productos", paqueteProductos);

    //calculateTotals(productos);

    setOrdenBlocked(!newItem.editable ?? false);
  }

  function validateAgregarProducto(cantidadRaw, productIdRaw, precio) {
    let cantidad = parseInt(cantidadRaw);
    let productoId = parseInt(productIdRaw);
    cantidad = isNaN(cantidad) ? 0 : cantidad;
    productoId = isNaN(productoId) ? 0 : productoId;

    const isAvailable = cantidad > 0;
    //  (formik.values.productSelected?.option?.cantidad ?? 0) >= cantidad;

    setDisableAgregarProducto(productoId <= 0 || !isAvailable);

    setDisableSeleccionarCantidad(productoId <= 0 /*|| !isAvailable*/);
    //{...formik.getFieldProps("cantidad")}

    const item = productos.find((item) => item.id === formik.values.productId);
    if (item == null) {
      //  toast.error("Error al pedir agregar producto.");
      return;
    }

    /*let newErrorCantidad =
      productoId > 0 && item.cantidad < cantidad
        ? "No existe cantidad suficiente en inventario"
        : "";
    setErrorCantidad(newErrorCantidad);*/
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  //  const formattedTotal = Singleton.getInstance().format(ordenTotal);

  console.log("--> CREATEORDEN Draw");
  const qtyTotal = productosAgregados.reduce(function (count, item, index) {
    count += item.cantidad;
    return count;
  }, 0);

  const priceTotalRaw = productosAgregados.reduce(function (
    count,
    item,
    index,
  ) {
    count += item.subTotal;
    return count;
  }, 0);

  const priceTotal = Singleton.getInstance().format(priceTotalRaw);

  const editable = item?.editable ?? true;

  return (
    <>
      <CreateClient
        ref={createClientesRef}
        item={modalData}
        defaultAsociadoId={defaultOnlyAsociadoId}
        returnBack={(e) => {
          modalRef.current.click();
        }}
        reloadClientes={(infos) => {
          if (infos == null) {
            return;
          }
        }}
      />
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropCrearProductoPaquete"
        hidden
      >
        Abrir Crear Orden 666
      </button>

      <div
        className="modal fade modal-xl"
        id="staticBackdropCrearProductoPaquete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropCrearProductoPaqueteLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {createMode ? "Crear" : "Editar"} Paquete
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <form className="row g-3" onSubmit={handleSubmit}>
                {!editable && (
                  <>
                    <div class="alert alert-warning" role="alert">
                      <span class="fw-bold">Modo bloqueado</span>. El paquete ya
                      fue usado una vez. Solo se pueden cambiar los precios de
                      los productos
                    </div>
                  </>
                )}
                <div className="form-control">
                  {<h5>Información General</h5>}

                  <div className="mb-3">
                    <div className="row">
                      <div className="col-6">
                        <label
                          htmlFor="validationApellidoPaterno"
                          className="form-label"
                        >
                          Nombre
                        </label>

                        <input
                          type="text"
                          className={`form-control ${invalidClass(
                            formik.errors.nombre,
                          )}`}
                          id="validationApellidoPaterno"
                          aria-describedby="eeee"
                          {...formik.getFieldProps("nombre")}
                          {...formikExtra.upperCase("nombre", formik)}
                          disabled={ordenBlocked}
                        />
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          {formik.errors.nombre}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="valid-feedback"></div>
                    </div>
                  </div>

                  <div className="separator" style={{ marginTop: "15px" }}>
                    <div className="mb-3" style={{ marginTop: "15px" }}>
                      <div className="row">
                        <div className="col">
                          <label
                            htmlFor="validationApellidoPaterno"
                            className="form-label"
                          >
                            Producto
                          </label>

                          <AutocompleteGo
                            ref={refAutocompleteProducto}
                            options={productos}
                            liveMode={true}
                            placeholder="Buscar Producto por nombre, Código de barras o SKU..."
                            className={`form-select ${invalidClass(
                              formik.errors.ordenVentaDetalles,
                            )}`}
                            onChange={(e) => {
                              //formik.setFieldValue("sucursal", e);
                              console.log("-->onChange create Orden");
                              const id = e == null ? 0 : parseInt(e.id);
                              if (id === 0) {
                                formik.setFieldValue("cantidad", 1);
                              }
                              formik.setFieldValue("productId", id);

                              formik.setFieldValue("productSelected", e);

                              validateAgregarProducto(
                                formik.values.cantidad,
                                id,
                              );
                            }}
                            onInputChanged={(e) => {
                              //formik.setFieldValue("sucursal", e);

                              clearTimers();

                              addAlert(() => {
                                formik.setFieldValue("productoValue", e);
                                searchFetchData(e);
                              });
                            }}
                            readOnly={ordenBlocked}
                          >
                            <div className="valid-feedback">Looks good!</div>
                            <div
                              className="invalid-feedback"
                              style={{ display: "flex" }}
                            >
                              {errorCantidad}
                            </div>
                          </AutocompleteGo>
                        </div>
                        {/*   <div className="col-2">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            Precio
                          </label>

                           <CurrencyInput
                            initialValue={formik.values.precio}
                            currencySymbol="$"
                            onNewValueHandler={(e) => {
                              console.log(e);
                              formik.setFieldValue("precio", e);
                            }}
                          />
                          <input
                            type="number"
                            min="0"
                            className={`form-control ${invalidClass(
                              errorCantidad,
                            )}`}
                            style={{ textAlign: "center" }}
                            id="validationName"
                            aria-describedby="emailHelp"
                            value={formik.values.precio}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "precio",
                                e.currentTarget.value,
                              );
                              //{...formik.getFieldProps("cantidad")}

                              /*  validateAgregarProducto(
                                e.currentTarget.value,
                                formik.values.productId,
                              );* /
                            }}
                            disabled={false}
                          />
                        </div>*/}
                        <div className="col-2">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            Cantidad
                          </label>
                          <input
                            type="number"
                            min="0"
                            max="20"
                            className={`form-control ${invalidClass(
                              errorCantidad,
                            )}`}
                            style={{ textAlign: "center" }}
                            id="validationName"
                            aria-describedby="emailHelp"
                            value={formik.values.cantidad}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "cantidad",
                                e.currentTarget.value,
                              );
                              //{...formik.getFieldProps("cantidad")}

                              validateAgregarProducto(
                                e.currentTarget.value,
                                formik.values.productId,
                              );
                            }}
                            disabled={ordenBlocked}
                          />
                        </div>
                        <div
                          className="col-3"
                          style={{ alignContent: "center" }}
                        >
                          <button
                            className="btn btn-warning"
                            type="button"
                            id="button-addon2"
                            disabled={disableAgregarProducto | ordenBlocked}
                            onClick={(event) => addProduct(event, item)}
                          >
                            Agregar producto
                          </button>
                        </div>
                      </div>
                      <div className="row ">
                        <div className="valid-feedback"></div>
                      </div>
                      <div className="row">
                        <div className="container">
                          <div
                            className="separator"
                            style={{ marginTop: "15px" }}
                          >
                            <div
                              className={`form-control ${invalidClass(
                                formik.errors.productos,
                              )}`}
                            >
                              <table className="table caption-top">
                                <caption>Lista de productos</caption>
                                <thead>
                                  <tr>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Marca</th>
                                    <th
                                      scope="col"
                                      style={{
                                        width: "100px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Precio
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        width: "100px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Precio Bundle
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        width: "100px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Cantidad
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        width: "100px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Total
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        width: "100px",
                                        textAlign: "center",
                                      }}
                                      className="no-sort"
                                    >
                                      Acciones
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {productosAgregados.map((item, index) => {
                                    const nombre = item.producto.nombre;
                                    const marca =
                                      item.producto.marca?.nombre ?? "";

                                    const precioEnPaquete =
                                      item.precioEnPaquete;
                                    const endPrecio = precioEnPaquete
                                      ? precioEnPaquete
                                      : item.producto.precioVenta;

                                    const precio =
                                      Singleton.getInstance().format(
                                        item.producto.precioVenta,
                                      );

                                    const maxCantidad = item.maxCantidad;
                                    const cantidad = item.cantidad;
                                    const subTotal =
                                      Singleton.getInstance().format(
                                        endPrecio * cantidad,
                                      );

                                    const canPulse = item.canPulse
                                      ? "pulse-glow"
                                      : "";

                                    const errorPrecio = item.errorPrecio;

                                    return (
                                      <>
                                        <tr
                                          className={`${createOrdenStyles.tablecenter} ${canPulse}`}
                                        >
                                          <th scope="row">{nombre}</th>
                                          <td>{marca}</td>
                                          <td
                                            style={{
                                              textAlign: "center",
                                            }}
                                          >
                                            {precio}
                                          </td>
                                          <td>
                                            <div
                                              style={{
                                                position: "relative",
                                                width: "150px",
                                                display: "block",
                                              }}
                                            >
                                              <CurrencyInput
                                                initialValue={precioEnPaquete}
                                                value={precioEnPaquete}
                                                className={`form-control ${invalidClass(errorPrecio)}`}
                                                placeholder={precio}
                                                onNewValueHandler={(value) => {
                                                  //  console.log(p);
                                                  updateProduct(
                                                    index,
                                                    cantidad,
                                                    value,
                                                  );
                                                }}
                                              />

                                              {/**  <input
                                                ref={withMask("currency", {
                                                  groupSeparator: ",",
                                                  digits: 2,
                                                  numericInput: true,
                                                  rightAlign: false,
                                                  allowMinus: false,
                                                })}
                                                type="text"
                                                className={`form-control ${invalidClass(errorPrecio)}`}
                                                id="validationName"
                                                aria-describedby="emailHelp"
                                                value={precioEnPaquete}
                                                placeholder={precio}
                                                onInput={async (e) => {
                                                  const { selectionStart } =
                                                    e.target;

                                                  const aValue =
                                                    onlyNumbersFloat(
                                                      e.target.value,
                                                    );

                                                  console.log(
                                                    "---> " +
                                                      aValue +
                                                      "  _ " +
                                                      selectionStart,
                                                  );

                                                  //--
                                                  updateProduct(
                                                    index,
                                                    cantidad,
                                                    aValue,
                                                  );
                                                  /*  formik.setFieldValue(
                                                                                      "entrante",
                                                                                      aValue,
                                                                                    );

                                                                                    --
                                                                                      updateProduct(
                                                    index,
                                                    parseInt(
                                                      e.currentTarget.value,
                                                    ),
                                                  );
                                                  * /

                                                  // Restore cursor position in the next frame
                                                  window.requestAnimationFrame(
                                                    () => {
                                                      e.target.selectionStart =
                                                        selectionStart;
                                                      e.target.selectionEnd =
                                                        selectionStart;
                                                    },
                                                  );
                                                }}
                                                disabled={false}
                                              /> */}
                                              <div className="invalid-tooltip">
                                                {errorPrecio}
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <div
                                              style={{
                                                position: "relative",
                                                width: "100%",
                                                display: "block",
                                              }}
                                            >
                                              <input
                                                style={{
                                                  width: "100%",
                                                  textAlign: "center",
                                                }}
                                                type="number"
                                                min="1"
                                                step="1"
                                                value={cantidad}
                                                max={maxCantidad}
                                                onChange={(e) => {
                                                  //
                                                  updateProduct(
                                                    index,
                                                    Number.parseInt(
                                                      e.currentTarget.value,
                                                    ),
                                                    endPrecio,
                                                  );
                                                }}
                                                disabled={ordenBlocked}
                                              />
                                            </div>
                                          </td>

                                          <td
                                            style={{
                                              textAlign: "center",
                                            }}
                                          >
                                            {subTotal}
                                          </td>
                                          <td>
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <>
                                                {/*<button
                                                className={`btn btn-warning ${styles.tooltip}`}
                                                disabled={ordenBlocked}
                                                onClick={(event) => {
                                                  console.log(
                                                    "--->removeProduct",
                                                  );
                                                  loadBonoficacionItem(item);
                                                }}
                                                style={{
                                                  marginLeft: "0px",
                                                  marginRight: "5px",
                                                }}
                                                type="button"
                                              >
                                                <div>
                                                  <span
                                                    className={`${styles.tooltiptext}`}
                                                  >
                                                    Bonificación
                                                  </span>
                                                  <FaPercent />
                                                </div>
                                              </button>*/}
                                                <button
                                                  className={`btn btn-danger ${styles.tooltip}`}
                                                  onClick={(event) => {
                                                    console.log(
                                                      "--->removeProduct",
                                                    );

                                                    removeProduct(index);
                                                  }}
                                                  style={{ marginLeft: "0px" }}
                                                  type="button"
                                                  disabled={ordenBlocked}
                                                >
                                                  <div>
                                                    <span
                                                      className={`${styles.tooltiptext}`}
                                                    >
                                                      Eliminar
                                                    </span>
                                                    <FaRegCircleXmark />
                                                  </div>
                                                </button>
                                              </>
                                            </div>
                                          </td>
                                        </tr>
                                        {item.bonificaciones &&
                                          item.bonificaciones.map(
                                            (e, index) => {
                                              return (
                                                <tr key={index}>
                                                  <td
                                                    colSpan="5"
                                                    style={{
                                                      textAlign: "right",
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Bonificación
                                                  </td>
                                                  <td
                                                    style={{
                                                      textAlign: "right",
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    {e.codigo}
                                                  </td>
                                                  <td colSpan={2}></td>
                                                </tr>
                                              );
                                            },
                                          )}
                                      </>
                                    );
                                  })}

                                  <tr>
                                    <td
                                      colSpan="4"
                                      style={{
                                        textAlign: "right",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Cantidad Total :
                                    </td>
                                    <td
                                      style={{
                                        width: "100px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {qtyTotal}
                                    </td>
                                    <td>{priceTotal}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="valid-feedback"></div>
                            <div className="invalid-feedback">
                              {formik.errors.productos}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={buttonCancelModalRef}
                  >
                    Cancelar
                  </button>
                  {
                    <LoadingButton
                      style={{ height: "38px" }}
                      onClick={(e) => {
                        formik.handleSubmit();
                      }}
                      text={"Guardar"}
                      loadingText={"Guardando..."}
                      isLoading={isLoading}
                      isDisable={canSave}
                    />
                  }
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <ErrorModal
        ref={errorModalRef}
        returnToModalId="staticBackdropCrearProductoPaquete"
      />
    </>
  );
});

export default CreatePaquete;
